<template>
  <v-dialog
    v-model="dialog"
    width="500"
    height="350"
  >
    <v-card>
      <v-card-title>
        {{ text }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <v-col align="center">
            <v-progress-circular
              :size="70"
              indeterminate
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    openDialog: function (val) {
      this.dialog = val;
    },
  },
};
</script>

<style></style>
